import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import keyIconSrc from '../../../src/assets/images/key-circle.svg';
import arrowLeftSrc from '../../../src/assets/images/arrow-left.svg';
import IndexLink from '../partials/IndexLink'
import { ReactSVG } from 'react-svg';
import { connect } from 'react-redux';
import { getMessage as t, safe } from '../../utils/utils';
import { messagesSelector, currentThemeSelector } from '../../helpers/selectors';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import * as UserActions from '../../actions/user';
import { checkPassword } from '../../helpers';
import { PureTextField } from './fields/text';
import { addSuccessMsg } from '../../utils/flashMessage/creator';

const validate = (values, props) => {
  const errors = {};
  const { m } = props;

  if (!values.newPassword || !values.currentPassword) {
    errors.newPassword = m['error.form.required'];
  }

  const passError = checkPassword(values.newPassword, m);

  if (passError) errors.newPassword = passError;

  if (
    values.newPassword === values.currentPassword &&
    !!values.currentPassword &&
    !!values.newPassword
  ) {
    errors.newPassword = m['error.form.password.cannot_reset_same'];
  }

  return errors;
};

/**
 * @typedef {object} CredentialsProps
 * @property {string} [title]
 * @property {string} [subTitle]
 * @property {string} [currentPassword]
 * @property {Function} [customSubmit]
 */
class Credentials extends Component {
  submitCallback(formValues, form) {
    const { currentPassword, newPassword } = formValues || {};
    const { updateUserPassword, m } = this.props;

    updateUserPassword({ newPassword, oldPassword: currentPassword }).then((data) => {
      if (data.type === 'user/UPDATE_PASSWORD_SUCCESS') {
        form.restart();
        addSuccessMsg(t(m, 'title.password.change.success'));
      }
    });
  }

  render() {
    const { m, updatePasswordFetching, theme, customSubmit, initialValues } = this.props;
    const { credential } = theme.icons || {};

    // validate needs props.m — bind it so RFF <Form validate> receives a plain (values)=>errors fn
    const boundValidate = (values) => validate(values, this.props);

    const handleFormSubmit = customSubmit
      ? customSubmit
      : (values, form) => this.submitCallback(values, form);

    return (
      <Form
        validate={boundValidate}
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
      >
        {({ handleSubmit, submitting, form }) => (
          <form
            className="account-credentials-page"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="scope-content-header">
              <img
                className="scope-content-header-picture"
                src={credential ? credential : keyIconSrc}
                alt="key icon"
              />
              <div className="scope-content-header-title-container">
                <IndexLink to="/profile" className="scope-content-header-button-return">
                  <ReactSVG className="react-svg" src={arrowLeftSrc} />
                </IndexLink>
                <div className="scope-content-header-title">
                  {this.props.title || t(m, 'profile.section.credentials')}
                </div>
              </div>
            </div>
            <div className="scope-content-body">
              <div className="scope-section">
                <div className="scope-section-title">
                  {this.props.subTitle || t(m, 'profile.title.update.password')}
                </div>
                <div className="scope-section-fields">
                  {!safe(() => initialValues && initialValues.currentPassword) && (
                    <Field
                      name="currentPassword"
                      type="password"
                      placeholder={t(m, 'profile.label.current.password')}
                      label={t(m, 'profile.label.current.password')}
                      component={PureTextField}
                    />
                  )}
                  <Field
                    name="newPassword"
                    type="password"
                    placeholder={t(m, 'label.new.password')}
                    label={t(m, 'label.new.password')}
                    component={PureTextField}
                  />
                </div>
              </div>
            </div>
            <div className="scope-content-footer">
              <button
                type="submit"
                disabled={submitting}
                className={classnames('scope-submit-button primary-btn', {
                  'sub-class-disabled': updatePasswordFetching
                })}
              >
                {t(m, 'generic.save')}
              </button>
            </div>
          </form>
        )}
      </Form>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { user } = state;
  const { updatePasswordFetching } = user || {};

  return {
    updatePasswordFetching,
    m: messagesSelector(state),
    theme: currentThemeSelector(state),
    initialValues: {
      currentPassword: props.currentPassword
    }
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...UserActions
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Credentials);
